import type { IconProps } from '.';

/**
 * LinkedIn Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const LinkedInIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 18 18"
    fill="none"
    className={className}
  >
    <path
      d="M3.64062 15.8652H0.371094V5.35347H3.64062V15.8652ZM1.98828 3.94722C0.96875 3.94722 0.125 3.06831 0.125 2.01363C0.125 0.572221 1.67188 -0.341842 2.9375 0.396439C3.53516 0.712846 3.88672 1.34566 3.88672 2.01363C3.88672 3.06831 3.04297 3.94722 1.98828 3.94722ZM12.6055 15.8652V10.7675C12.6055 9.53706 12.5703 7.99019 10.8828 7.99019C9.19531 7.99019 8.94922 9.29097 8.94922 10.6621V15.8652H5.67969V5.35347H8.80859V6.79488H8.84375C9.30078 5.98628 10.3555 5.10738 11.9375 5.10738C15.2422 5.10738 15.875 7.28706 15.875 10.0996V15.8652H12.6055Z"
      fill="white"
    />
  </svg>
);

export default LinkedInIcon;
